import React, { useState } from "react";
import {
  Box,
  TextField,
  Button,
  FormControlLabel,
  Checkbox,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { Link } from "react-router-dom";
import { Stack } from "@mui/system";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
type Props = {
  isRoom?: boolean;
  appartamento?: boolean;
};

const Contact = ({ isRoom, appartamento }: Props) => {
  const isDesktop = useMediaQuery("(min-width: 1024px)");
  const isSmScreen = useMediaQuery("(max-width:1090px)");

  const [formData, setFormData] = useState({
    nome: "",
    cognome: "",
    telefono: "",
    email: "",
    appartamento: "",
    messaggio: "",
    autorizzazione: false,
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    try {
      const response = await fetch(
        "https://partenopefinale-4j4e.vercel.app/send-email",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );


      if (response.ok) {
        alert("Email inviata con successo!");
      } else {
        alert("Errore nell'invio dell'email.");
      }
    } catch (error) {
      console.error("Errore:", error);
      alert("Errore di connessione al server.");
    }
  };

  return (
    <Box
      width={"100%"}
      display={"flex"}
      flexDirection={"column"}
      alignItems={"center"}
      gap={5}
      justifyContent={isSmScreen ? "flex-end" : undefined}
      marginTop={isRoom || isSmScreen ? "0px" : "80px"}
      p={isSmScreen ? "0 9vw" : 7}
    >
      <Box display={isRoom ? "none" : undefined} textAlign="start" my={0.5}>
        <Typography
          fontSize={isSmScreen ? "22px" : undefined}
          variant="h4"
          fontWeight="bold"
          color="#0C6D8D"
          gutterBottom
        >
          Scrivici per un appuntamento
        </Typography>
        <Typography
          fontSize={isSmScreen ? "16px" : "18px"}
          variant="body1"
          color="textSecondary"
        >
          Riempi il form e inviaci una mail. Ti risponderemo non appena
          possibile.
        </Typography>

        {/* Aggiunta delle informazioni di contatto */}
        <Typography
          fontSize={isSmScreen ? "22px" : "18px"}
          variant="body1"
          color="textSecondary"
          mt={2}
          display={"flex"}
          alignItems={"center"}
        >
          {" "}
          <PhoneIcon fontSize="small" style={{ marginRight: 8 }} />
          <a
            style={{
              textDecoration: "none",
              color: "#5d5d5d",
            }}
            href="tel:+08119640374"
          >
            081 196 40 374
          </a>
        </Typography>
        <Typography
          display={"flex"}
          alignItems={"center"}
          fontSize={isSmScreen ? "22px" : "18px"}
          variant="body1"
          color="textSecondary"
        >
          <EmailIcon fontSize="small" style={{ marginRight: 8 }} />

          <a
            style={{
              textDecoration: "none",
              color: "#5d5d5d",
            }}
            href="mailto:esempio@email.com"
          >
            partenopeimmobiliare@gmail.com
          </a>
        </Typography>
      </Box>
      <Box
        component="form"
        onSubmit={handleSubmit}
        display="flex"
        flexDirection="column"
        alignItems="center"
        maxWidth={"700px"}
        width={"100%"}
        padding={0}
        bgcolor="white"
        borderRadius={2}
      >
        {" "}
        <TextField
          label="Nome"
          name="nome"
          fullWidth
          required
          margin="normal"
          value={formData.nome}
          onChange={handleChange}
        />
        <TextField
          label="Cognome"
          name="cognome"
          required
          fullWidth
          margin="normal"
          value={formData.cognome}
          onChange={handleChange}
        />
        <TextField
          label="Telefono"
          name="telefono"
          fullWidth
          margin="normal"
          required
          value={formData.telefono}
          onChange={handleChange}
        />
        <TextField
          label="Email"
          name="email"
          type="email"
          fullWidth
          margin="normal"
          required
          value={formData.email}
          onChange={handleChange}
        />
        <TextField
          label="Appartamento"
          name="appartamento"
          fullWidth
          margin="normal"
          value={appartamento || formData.appartamento}
          onChange={handleChange}
        />
        <TextField
          label="Messaggio"
          name="messaggio"
          multiline
          rows={4}
          fullWidth
          margin="normal"
          required
          value={formData.messaggio}
          onChange={handleChange}
        />
        <div
          style={{
            marginTop: "20px",
          }}
        ></div>
        <Stack alignItems={"center"} flexDirection={"row"}>
          {" "}
          <Checkbox
            name="autorizzazione"
            checked={formData.autorizzazione}
            onChange={handleChange}
          />
          <Box>
            <Link
              style={{
                paddingBottom: 2,
                textDecoration: "none",

                color: "#666666",
              }}
              to="/privacy-policy"
            >
              {" "}
              Autorizzo il trattamento dei dati (Regolamento UE 2016/679) e ho
              letto la Privacy Policy
            </Link>
          </Box>
        </Stack>
        <Button
          type="submit"
          variant="contained"
          color="info"
          sx={{ mt: 4, width: "100%" }}
        >
          Invia
        </Button>
      </Box>
      <Box display={isRoom ? "none" : undefined}>
        {" "}
        <iframe
          title={"googleMapsTitle"}
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2351.172535415726!2d14.2335!3d40.8443!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x133b087654321234%3A0xabcdef1234567890!2sVia%20Giuseppe%20Orsi%2C%2028%2C%2080128%20Napoli%20NA%2C%20Italy!5e0!3m2!1sit!2sit!4v1700000000000!5m2!1sit!2sit"
          width={isDesktop ? "650vw" : "320vw"}
          height={isDesktop ? "500vh" : "180vh"}
          style={{ border: 0 }}
          allowFullScreen={true}
          loading="lazy"
        ></iframe>
      </Box>

      <div
        style={{
          margin: "20px 0",
        }}
      ></div>
    </Box>
  );
};

export default Contact;
